// Logos oficiales (inline SVG) de los canales del CRM.
// Sin requests externas, escalables, accesibles.

export default function CanalLogo({ canal, size = 14, className = '', title }) {
  const t = title || (canal === 'whatsapp' ? 'WhatsApp' : canal === 'instagram' ? 'Instagram' : canal)
  const props = {
    width: size, height: size,
    role: 'img',
    'aria-label': t,
    className,
  }
  if (canal === 'whatsapp') return <WhatsApp {...props} />
  if (canal === 'instagram') return <Instagram {...props} />
  if (canal === 'email') return <Email {...props} />
  if (canal === 'webchat') return <Webchat {...props} />
  return <span style={{ fontSize: size }}>{t?.[0]?.toUpperCase() || '?'}</span>
}

function WhatsApp(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path fill="#25D366" d="M16 0C7.163 0 0 7.163 0 16c0 2.82.737 5.467 2.027 7.76L0 32l8.453-2.213A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0Z"/>
      <path fill="#fff" d="M23.504 19.06c-.345-.173-2.043-1.008-2.361-1.124-.317-.116-.547-.173-.778.173-.23.345-.892 1.124-1.094 1.355-.202.23-.403.26-.749.086-.345-.173-1.459-.538-2.78-1.715-1.028-.917-1.722-2.049-1.924-2.394-.201-.346-.022-.532.151-.703.156-.155.346-.404.519-.605.173-.202.23-.346.346-.577.115-.23.058-.432-.029-.605-.087-.173-.778-1.875-1.066-2.566-.281-.674-.567-.583-.779-.594l-.663-.012c-.23 0-.605.087-.922.432-.317.346-1.21 1.182-1.21 2.884 0 1.701 1.239 3.346 1.412 3.577.173.23 2.44 3.726 5.91 5.225.825.356 1.47.569 1.971.728.828.263 1.581.226 2.176.137.664-.099 2.043-.836 2.331-1.643.288-.808.288-1.5.202-1.644-.087-.144-.317-.23-.663-.404Z"/>
    </svg>
  )
}

function Instagram(props) {
  // Logo Instagram con gradient oficial
  const id = 'ig-grad-' + Math.random().toString(36).slice(2, 8)
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id={id} cx="0.3" cy="1.07" r="1.2">
          <stop offset="0" stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${id})`} />
      <path fill="#fff" d="M16 8c-2.173 0-2.445.009-3.298.048-.851.039-1.432.174-1.941.371a3.92 3.92 0 0 0-1.417.923 3.92 3.92 0 0 0-.923 1.417c-.197.509-.332 1.09-.371 1.941C8.01 13.555 8 13.827 8 16c0 2.173.009 2.445.048 3.298.039.851.174 1.432.371 1.941.207.531.483.981.923 1.421.44.44.89.717 1.421.923.509.197 1.09.332 1.941.371.853.039 1.125.048 3.298.048s2.445-.009 3.298-.048c.851-.039 1.432-.174 1.941-.371a3.92 3.92 0 0 0 1.421-.923c.44-.44.717-.89.923-1.421.197-.509.332-1.09.371-1.941.039-.853.048-1.125.048-3.298s-.009-2.445-.048-3.298c-.039-.851-.174-1.432-.371-1.941a3.92 3.92 0 0 0-.923-1.417 3.92 3.92 0 0 0-1.421-.923c-.509-.197-1.09-.332-1.941-.371C18.445 8.009 18.173 8 16 8Zm0 1.441c2.136 0 2.389.008 3.232.046.78.036 1.203.166 1.485.276.373.145.64.318.92.598.28.28.453.547.598.92.11.282.24.706.276 1.485.038.844.046 1.097.046 3.234s-.008 2.389-.046 3.232c-.036.78-.166 1.203-.276 1.485-.145.373-.318.64-.598.92a2.477 2.477 0 0 1-.92.598c-.282.11-.706.24-1.485.276-.844.038-1.096.046-3.232.046-2.137 0-2.39-.008-3.234-.046-.78-.036-1.203-.166-1.485-.276a2.477 2.477 0 0 1-.92-.598 2.477 2.477 0 0 1-.598-.92c-.11-.282-.24-.706-.276-1.485-.038-.844-.046-1.096-.046-3.232 0-2.137.008-2.39.046-3.234.036-.78.166-1.203.276-1.485.145-.373.318-.64.598-.92a2.477 2.477 0 0 1 .92-.598c.282-.11.706-.24 1.485-.276.844-.038 1.097-.046 3.234-.046Zm0 2.452a4.107 4.107 0 1 0 0 8.214 4.107 4.107 0 0 0 0-8.214Zm0 6.773a2.666 2.666 0 1 1 0-5.332 2.666 2.666 0 0 1 0 5.332Zm5.23-6.937a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0Z"/>
    </svg>
  )
}

function Email(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#0d9488" />
      <path fill="#fff" d="M6 11.5v9.5c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-9.5l-10 6L6 11.5Zm10 4.5L26 10H6l10 6Z"/>
    </svg>
  )
}

function Webchat(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#1A3461" />
      <path fill="#fff" d="M7 10a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-7l-5 4v-4a3 3 0 0 1-3-3v-8Z"/>
    </svg>
  )
}
